<!-- 
Listing of roles.
-->
<template>
  <div>
    <v-card class="home">
      <our-simple-table-header
        :total-items="listing.paging.totalItems"
        @click:refresh="refresh"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table 
        ref="roleTable" 
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems" 
        :no-data-text="noDataText"
        must-sort 
        hide-actions
        @click:refresh="refresh" 
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="top-align" @click.stop="openRole(props.item.id)">
            <our-nav-col :row="props.item.name"/>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.prismsName }}</td>
            <td>
              {{ pluralise(props.item.permissions.length) }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import tableMixins from "@/mixins/table.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/roles/action-types";
import * as mutation from "@/store/roles/mutation-types";

export default {
  mixins: [tableMixins, lookupMixins],
  data() {
    return {
      action: action.LIST,
      pagingMutation: mutation.LIST_SET_PAGING
    };
  },
  computed: {
    headers() {
      return [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Name", value: "Name", sortable: true },
        { text: "PRISMS Name", value: "PrismsName", sortable: true },
        { text: "Permissions", value: "Permissions", sortable: false }
      ];
    },
    listing() {
      return this.$store.state.roles.listing;
    },
    loaded() {
      return this.listing.loaded;
    },
    permissionClaimTypes() {
      return this.$store.state.lookups.data.permissionClaimTypes;
    }
  },
  watch: {
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if (!this.listing.loaded && !this.listing.loading) {
        this.populate();
      }
    },
    openRole(id) {
      this.$router.push(`/roles/${id}`);
    },
    pluralise(count) {
      if (count == 0) return "No permissions";
      if (count == 1) return "1 permission";
      return `${count} permissions`;
    }
  }
};
</script>
